<template>
  <div
    class="row success-message text-center m-b-20"
  >
    <h1
      class="title md-title"
    >
      <span v-class="welcomeMessageClass" />
    </h1>
    <p
      v-t="opClosedLine1"
      class="subtitle p-t-10 p-b-10"
    />
    <p
      class="text-center p-t-15 prp_footer_contact"
      v-html="$t('ORP_CLOSED_LINE2')"
    />
  </div>
</template>

<script>

import messages from '../locales';
import { capitalize } from 'lodash';

export default {

  props: {
    applicantType: {
      type: String,
      default: ''
    },
  },

  computed: {
    opClosedLine1() {
      return this.$t('ORP_CLOSED_LINE1', { applicantType: this.applicantType });
    },
    welcomeMessageClass() {
      return `${this.capitalizedType}-registration-welcome-message`;
    },
    capitalizedType () {
      return capitalize(this.applicantType);
    }
  },

  i18n: {
    messages,
    locale: 'en',
  },
};
</script>